// extracted by mini-css-extract-plugin
export var carrierTab = "_3o-0";
export var carrierTabActive = "_3o-1 _3o-0";
export var carrierTabInactive = "_3o-2 _3o-0";
export var carrierTabLabel = "_3o-3";
export var carrierTabLabelActive = "_3o-4 _3o-3";
export var carrierTabLabelInactive = "_3o-5 _3o-3";
export var carrierTabPercentage = "_3o-6";
export var carrierTabPercentageActive = "_3o-7 _3o-6";
export var carrierTabPercentageInactive = "_3o-8 _3o-6";
export var carrierTabWinnable = "_3o-9";
export var carrierTabWinnableActive = "_3o-a _3o-9";
export var carrierTabWinnableInactive = "_3o-b _3o-9";
export var comparisonContainer = "_3o-d";
export var missingRateButton = "_3o-n";
export var missingRateButtonActive = "_3o-o _3o-n";
export var missingRateButtonInactive = "_3o-p _3o-n";
export var missingRateButtonLabel = "_3o-q";
export var missingRateButtonLabelActive = "_3o-r _3o-q";
export var missingRateButtonLabelInactive = "_3o-s _3o-q";
export var sidebar = "_3o-c";
export var strategyButton = "_3o-e";
export var strategyButtonActive = "_3o-f _3o-e";
export var strategyButtonDescription = "_3o-k";
export var strategyButtonDescriptionActive = "_3o-l _3o-k";
export var strategyButtonDescriptionInactive = "_3o-m _3o-k";
export var strategyButtonInactive = "_3o-g _3o-e";
export var strategyButtonLabel = "_3o-h";
export var strategyButtonLabelActive = "_3o-i _3o-h";
export var strategyButtonLabelInactive = "_3o-j _3o-h";
export var unitToggleButton = "_3o-t";
export var unitToggleButtonActive = "_3o-u _3o-t";
export var unitToggleButtonInactive = "_3o-v _3o-t";
export var unitToggleButtonLabel = "_3o-w";
export var unitToggleButtonLabelActive = "_3o-x _3o-w";
export var unitToggleButtonLabelInactive = "_3o-y _3o-w";